import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
const styles = {
  container: {
    maxWidth: '1440px',
    marginLeft: '0',
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginBottom: '20px',
    color: '#333',
  },
  form: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '10px',
    marginBottom: '20px',
  },
  input: {
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
  },
  textarea: {
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    gridColumn: '1 / -1',
  },
  button: {
    padding: '10px 20px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  th: {
    backgroundColor: '#f8f9fa',
    padding: '12px',
    textAlign: 'left',
    borderBottom: '2px solid #dee2e6',
  },
  td: {
    padding: '12px',
    borderBottom: '1px solid #dee2e6',
  },
}; 

const ToggleButton = styled.button`
  margin-bottom: 10px;
  padding: 10px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #45a049;
  }
`;

const Container = styled.div`
  padding: 20px;
  margin: 0 auto;
`;

export default function BonusAccumulationStatus() {
  const [payments, setPayments] = useState([]);
  const [newPayment, setNewPayment] = useState({
    user_id: '',
    order_id: '',
    item_name: '',
    payment_amount: '',
    details: ''
  });
  const [isInfoVisible, setIsInfoVisible] = useState(false); // 설명 표시 여부 상태

  const handleToggleInfo = () => {
    setIsInfoVisible((prev) => !prev); // 버튼 클릭 시 상태 토글
  };


  useEffect(() => {
    fetchPayments();
  }, []);

  const fetchPayments = async () => {
    try {
      const res = await fetch('http://localhost:4000/api/payments/getPayments', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await res.json();
      setPayments(data);
    } catch (error) {
      console.error('보너스 적립 내역 조회 중 오류 발생:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewPayment({ ...newPayment, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('http://localhost:4000/api/payments/addPayment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newPayment)
      });
      const data = await res.json();
      setPayments([...payments, data]);
      setNewPayment({ user_id: '', order_id: '', item_name: '', payment_amount: '', details: '' });
    } catch (error) {
      console.error('보너스 적립 내역 추가 중 오류 발생:', error);
    }
  };

  return (
    <Container>
    {/* <ToggleButton onClick={handleToggleInfo}>
      {isInfoVisible ? '숨기기' : '설명 보기'}
    </ToggleButton>

    {isInfoVisible && (
      <p>
        ants_user_rank 테이블에 저장된 사용자의 등급에 따라 보너스 포인트가 적립됩니다.

        등급에 따라 적립되는 보너스 포인트가 다르게 존재합니다
        파이(포인트)는 회원이 구매한 상품의 금액에 따라 적립되며, 적립된 포인트는 다음 구매 시 사용할 수 있습니다.
        
      </p>
    )} */}

    <div style={styles.container}>
      <h2 style={styles.title}>보너스 적립 현황</h2>
      <form style={styles.form} onSubmit={handleSubmit}>
        <input
          style={styles.input}
          type="text"
          name="user_id"
          value={newPayment.user_id}
          onChange={handleChange}
          placeholder="사용자 ID"
          required
        />
        <input
          style={styles.input}
          type="text"
          name="order_id"
          value={newPayment.order_id}
          onChange={handleChange}
          placeholder="주문 ID"
          required
        />
        <input
          style={styles.input}
          type="text"
          name="item_name"
          value={newPayment.item_name}
          onChange={handleChange}
          placeholder="상품명"
          required
        />
        <input
          style={styles.input}
          type="number"
          name="payment_amount"
          value={newPayment.payment_amount}
          onChange={handleChange}
          placeholder="결제 금액"
          required
        />
        <textarea
          style={styles.textarea}
          name="details"
          value={newPayment.details}
          onChange={handleChange}
          placeholder="상세 내용"
        />
        <button style={styles.button} type="submit">적립 내역 추가</button>
      </form>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>ID</th>
            <th style={styles.th}>사용자 ID</th>
            <th style={styles.th}>주문 ID</th>
            <th style={styles.th}>상품명</th>
            <th style={styles.th}>결제 금액</th>
            <th style={styles.th}>결제 일시</th>
            <th style={styles.th}>상세 내용</th>
          </tr>
        </thead>
        <tbody>
          {payments.map(payment => (
            <tr key={payment.id}>
              <td style={styles.td}>{payment.id}</td>
              <td style={styles.td}>{payment.user_id}</td>
              <td style={styles.td}>{payment.order_id}</td>
              <td style={styles.td}>{payment.item_name}</td>
              <td style={styles.td}>{payment.payment_amount}원</td>
              <td style={styles.td}>{new Date(payment.payment_date).toLocaleString()}</td>
              <td style={styles.td}>{payment.details}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </Container>
  );
}